/**
 * 海艺-签名密钥
 */
export const signSecret = {
  key: 'XY2x3b57etxA015ybwpjwGtka',
  publicKey: `-----BEGIN PUBLIC KEY-----
MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQC6E2qASalqfMDxF8Mg18iYtEr/
XFa8iJ1DXBKYQl5X7jNZY+PAglGKlXD5XFdl5OJosFqUNcrTAAEQgDcXGcsBSoGo
YCAPZyBhjN2C3K3AVcDuzWL/FgXf20pbkzSv22HfRVQupvFH5L3Wexvf9wZdnwqt
g0YfflkfPiMBDYo9VQIDAQAB
-----END PUBLIC KEY-----`,
}
